import maDamagedItemBtn from '@/components/buttons'
import maNavbarCategory from '@/components/navbarCategories'
import maButtonNext from '@/components/button-blue'
import maNavbarStepper from '@/components/navbarStepper'
import {
  LEVEL_1,
  INTERIOR_PROPERTY,
  MULTIDAMAGE,
  OTHERS,
  VITRE_INSERT
} from '@/constants'
import { mapState, mapMutations, mapActions } from 'vuex'
import generateUniqueId from '@/utils/generateUniqueId'
import { cloneDeep } from 'lodash'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_DAMAGED_ITEM,
  WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
  WARRANTY_UPDATE_DAMAGED_PART_KEY,
  WARRANTY_UPDATE_LAST_SELECTED_KEY,
  WARRANTY_UPDATE_LAST_SELECTED_VALUE,
  WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_IS_MULTIDAMAGE,
  WARRANTY_UPDATE_MULTIDAMAGE
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damagedItems',

  mixins: [flowMixin, userFlowMixin],

  data: function () {
    return {
      /**
       *  @property {Array} dataDamagedItems Array retrieved from the apiGetForms service which contains the info of all the damage types.
       */
      dataDamagedItems: [],
      dataDamagedItemsSelected: {},
      listKey: generateUniqueId(),
      isContinueDisabled: true,
      itemsToDamageDetails: [VITRE_INSERT, OTHERS]
    }
  },

  components: {
    maDamagedItemBtn,
    maNavbarCategory,
    maButtonNext,
    maNavbarStepper
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyReport: 'report',
      stateWarrantyForms: 'forms',
      stateWarrantyDamageTypeLiteral: 'damageTypeLiteral',
      stateIsMultidamage: 'isMultidamage',
      stateMultidamage: 'multidamage',
      stateMaxPiecesId: 'maxPiecesId'
    }),

    /**
     * Based on the route category processes and returns the title
     */
    titleCategory() {
      const category = this.getDamageType
      const title = category.replace('_', ' ').replace('_', ' ').toLowerCase()
      return title
    },

    isMultidamage() {
      return this.stateIsMultidamage
    },

    /**
     * Sets the damageType title based on the stateWarrantyDamageTypeLiteral if exists, else it gets it from the local storage
     */
    titleNavBar() {
      const titleLocalStorage = localStorage.getItem('damageTypeLiteral') || ''
      const value = this.stateWarrantyDamageTypeLiteral || titleLocalStorage
      return String(value)
    },
    flowName() {
      return this.getUserFlow
    }
  },
  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyClearSelectedDamagedParts:
        WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
      mutWarrantyUpdateDamagedItem: WARRANTY_UPDATE_DAMAGED_ITEM,
      mutWarrantyUpdateDamagedItemKey: WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
      mutWarrantyUpdateDamagedPartKey: WARRANTY_UPDATE_DAMAGED_PART_KEY,
      mutWarrantyUpdateSelectedValue: WARRANTY_UPDATE_LAST_SELECTED_VALUE,
      mutWarrantyUpdateSelectedKey: WARRANTY_UPDATE_LAST_SELECTED_KEY,
      mutWarrantyUpdateSelectedDamagedParts:
        WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS,
      mutWarrantyUpdateIsMultidamage: WARRANTY_UPDATE_IS_MULTIDAMAGE,
      mutWarrantyUpdateMultidamage: WARRANTY_UPDATE_MULTIDAMAGE
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS
    }),

    handleOnClickPrevRoute() {
      if (this.isMultidamage) {
        this.mutWarrantyUpdateIsMultidamage(false)
        this.mutWarrantyUpdateMultidamage({})
        this.routeToDamagesTypes()
      } else {
        const damageTypeViewName = 'damages-types'
        this.goToView(damageTypeViewName)
      }
    },

    routeToDamagesTypes() {
      const damageTypeViewName = 'damages-types'
      const propertyType = this.getPropertyType
      this.goToView(damageTypeViewName, { propertyType })
    },

    /**
     * Updates the report state, clears forms state, and calls the action actWarrantyGetForms, pushes the params for the next route
     */
    handleClickDamagedItem(damagedItem, literal) {
      if (!this.isMultidamage) {
        this.mutWarrantyUpdateDamagedItem(literal)
        localStorage.setItem('damagedItemLiteral', literal)
        let value = damagedItem
        let key = this.dataDamagedItems.name
        this.mutWarrantyUpdateDamagedItemKey(key)
        localStorage.setItem('damagedItemKey', key)
        this.mutWarrantyUpdateReport({ key, value })
        this.mutWarrantyClearForms()
        localStorage.setItem('report', JSON.stringify(this.stateWarrantyReport))

        this.routeToNext(value)
      }
    },

    handleOnQuantityChange(key, value) {
      if (this.dataDamagedItemsSelected[key] != null) {
      if (value === 0) {
        delete this.dataDamagedItemsSelected[key]
      } else {
        this.dataDamagedItemsSelected[key] = value
      }
      } else {
        this.dataDamagedItemsSelected[key] = value
      }

      this.listKey = generateUniqueId() // force buttons to rerender
      this.isContinueDisabled =
        Object.keys(this.dataDamagedItemsSelected).length <= 0
    },

    filteredForm(form) {
      let formFiltered = {}
      Object.keys(this.stateWarrantyReport[0]).forEach((key) => {
        form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
          (input) => {
            return input.name !== key
          }
        )
      })

      form.form.regions[0].inputs = form.form.regions[0].inputs.filter(
        (input) => {
          return input.type !== 'hidden'
        }
      )
      formFiltered = form.form.regions[0].inputs[0]

      return formFiltered
    },
    /**
     * Updates the state report, calls action actWarrantyGetForms to get the froms and update the data property dataDamagedItems with the required forms
     */
    getForm() {
      this.mutWarrantyClearReport()
      let key = 'propertyType'
      let value = this.getPropertyType
      this.mutWarrantyUpdateReport({ key, value })
      key = 'ASSETS'
      value = this.getDamageType
      this.mutWarrantyUpdateReport({ key, value })
      this.mutWarrantyClearForms()
      const warrantyId = this.getWarrantyId
      const report = this.stateWarrantyReport

      this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
        if (resp.formsUpdated) {
          this.dataDamagedItems = this.filteredForm(this.stateWarrantyForms[0])
          if (!this.dataDamagedItems.options) {
            this.updateStateProps()
            this.routeToDamageDetails()
          } else {
            this.mutWarrantyClearForms()
          }
        }
      }).catch((error) => {
        const context = {
          component: 'damagedItems',
          method: 'getForm',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error getting forms: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'getForm'
        )
      })
    },

    /**
     * Updates the props that are needed for a damaged item without level1 or level2, and it in the absence of those it will add level1,level2 for the damagedItem and the damagedPart that would normally be stored in this steps and are needed for the damageDetails view
     */
    updateStateProps() {
      const category = 'ASSETS'
      this.mutWarrantyUpdateDamagedPartKey(category)
      this.mutWarrantyUpdateDamagedItemKey(LEVEL_1)
      localStorage.setItem('damagedItemKey', category)
      const literal = this.stateWarrantyDamageTypeLiteral
      const damagedPart = this.getDamageType
      this.mutWarrantyUpdateSelectedDamagedParts({ literal, damagedPart })
      this.mutWarrantyUpdateDamagedItem(literal)
      localStorage.setItem('damagedItemLiteral', literal)
    },
    updateStatePropsForVitrerie() {
      const lastSelected = 'MENUISERIE_VITRERIE'
      this.mutWarrantyUpdateSelectedKey(lastSelected)
      this.mutWarrantyUpdateSelectedValue(lastSelected)

      const category = 'ASSETS'
      this.mutWarrantyUpdateDamagedPartKey(category)
    },
    updateSelectedDamagedParts(valueSelected) {
      if (valueSelected === VITRE_INSERT) {
        this.updateStatePropsForVitrerie()
      }

      this.mutWarrantyClearSelectedDamagedParts()
      const literal = this.stateWarrantyDamageTypeLiteral
      const damagedPart = this.getDamageType
      this.mutWarrantyUpdateSelectedDamagedParts({ literal, damagedPart })
    },

    /**
     * Adds the params for the damage details route and redirects to it
     */
    routeToDamageDetails() {
      const damageDetailsViewName = 'damage-details'
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      const damagedItem = LEVEL_1
      this.goToView(damageDetailsViewName, {
        propertyType,
        damageType,
        damagedItem
      })
    },

    /**
     * If the component has a self_care_icon associated we will return input type to show the icon
     * else we will return input-txt
     */
    retrieveButtonType(imageIcon) {
      return imageIcon && imageIcon !== '' ? 'input-incremental' : 'input-txt'
    },

    getDamagePieceId(damageKey) {
      const maxId = this.stateMaxPiecesId.find(
        (maxId) => maxId.piece === damageKey
      )
      return maxId != null ? +maxId.max_id : 0
    },

    handleOnContinue() {
      const multiDamage = {
        propertyType: this.getPropertyType,
        assets: INTERIOR_PROPERTY,
        damages:
          this.stateMultidamage.damages != null
            ? cloneDeep(this.stateMultidamage.damages)
            : []
      }

      // If in the state there are types of pieces that have been removed now, removed them
      if (multiDamage.damages.length > 0) {
        const addedDamageKeys = Object.keys(this.dataDamagedItemsSelected)

        multiDamage.damages.forEach((damageType, i) => {
          if (!addedDamageKeys.includes(damageType.damageKey)) {
            multiDamage.damages = multiDamage.damages.filter(
              (type) => type.damageKey !== damageType.damageKey
            )
          }
        })
      }

      // Create a piece according to each damageKey quantity
      Object.entries(this.dataDamagedItemsSelected).forEach(
        ([damageKey, damageQuantity]) => {
          const existingDamageKey = multiDamage.damages.find(
            (damageType) => damageType.damageKey === damageKey
          )
          const maxId = this.getDamagePieceId(damageKey)
          const literal = this.dataDamagedItems.options.find(
            (damagedItem) => damagedItem.key === damageKey
          ).literal
          const damagePiece = {
            id: generateUniqueId(),
            damageKey,
            literal,
            pieces: []
          }

          // If in the state there are more pieces for each piece type than now, removed them
          if (
            existingDamageKey != null &&
            existingDamageKey.pieces.length > damageQuantity
          ) {
            for (
              let i = existingDamageKey.pieces.length - 1;
              i >= damageQuantity;
              i--
            ) {
              existingDamageKey.pieces.splice(i, 1)
            }
          }

          for (let i = 1; i <= damageQuantity; i++) {
            const pieceId = maxId + i
            // If piece type already exists in the state and its number of pieces is less
            // than the current quantity, add the rest of pieces
            if (existingDamageKey != null) {
              if (existingDamageKey.pieces.length < i) {
                existingDamageKey.pieces.push({
                  id: generateUniqueId(),
                  pieceId
                })
              }
              // If piece type doesn't exist in the state, push the new piece
            } else {
              damagePiece.pieces.push({ id: generateUniqueId(), pieceId })
            }
          }

          // If piece type doesn't exist in the state, add it
          if (existingDamageKey == null) {
            multiDamage.damages.push(damagePiece)
          }
        }
      )

      this.mutWarrantyUpdateMultidamage(multiDamage)
      this.routeToAddDamagedParts(MULTIDAMAGE)
    },

    routeToAddDamagedParts(damagedItem) {
      const warrantyId = this.getWarrantyId
      const report = this.stateWarrantyReport

      this.actWarrantyGetForms({ report, warrantyId }).then((resp) => {
        if (resp.formsUpdated) {
          const damagedPartsViewName = 'damaged-parts'
          const propertyType = this.getPropertyType
          const damageType = this.getDamageType
          this.goToView(damagedPartsViewName, {
            propertyType,
            damageType,
            damagedItem
          })
        }
      }).catch((error) => {
        const context = {
          component: 'damagedItems',
          method: 'routeToAddDamagedParts',
          route: this.$route.path
        }

        const tags = prepareErrorForSentry(error, context)

        this.sendSentryError(
          `Error getting forms for damaged parts: ${error.message || 'Unknown error'}`,
          error.response && error.response.status >= 500 ? 'error' : 'warning',
          tags,
          this.getSinisterId,
          'routeToAddDamagedParts'
        )
      })
    },

    setInitialSelectedItems() {
      this.stateMultidamage.damages.forEach((damageType) => {
        this.dataDamagedItemsSelected[damageType.damageKey] =
          damageType.pieces.length
        this.isContinueDisabled =
          Object.keys(this.dataDamagedItemsSelected).length <= 0
      })
    },

    routeToNext(valueSelected) {
      if (this.itemsToDamageDetails.includes(valueSelected)) {
        this.updateSelectedDamagedParts(valueSelected)
        this.routeToDamageDetails()
      } else {
        this.routeToAddDamagedParts(valueSelected)
      }
    }
  },

  /**
   * Updates dataDamagedItems, if the stateWarrantyForms's length is 0, it executes getForm function
   * Set multidamage to true if damageType is 'BIENS_IMMOBILIERS_INTERIEURS'
   */
  async mounted() {
    //Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)

    if (
      this.stateWarrantyForms.length === 0 ||
      this.stateWarrantyReport.length >= 1
    ) {
      await this.getForm()
    } else {
      this.dataDamagedItems =
        this.stateWarrantyForms[0].form.regions[0].inputs[1]
      this.mutWarrantyClearForms()
    }
    if (this.$route.params.damageType === INTERIOR_PROPERTY) {
      this.mutWarrantyUpdateIsMultidamage(true)
      if (
        this.stateMultidamage.damages != null &&
        this.stateMultidamage.damages.length > 0
      ) {
        this.setInitialSelectedItems()
      }
    } else {
      this.mutWarrantyUpdateIsMultidamage(false)
      this.mutWarrantyUpdateMultidamage({})
    }
  }
}
